// removed by extract-text-webpack-plugin
module.exports = {"container":"QyFVJ"};


//////////////////
// WEBPACK FOOTER
// ./app/components/comment-form-wrapper/comment-form-wrapper.scss
// module id = 1570
// module chunks = 0